import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { Dependente } from "../../models/dependente";
import { IGetDependentesUseCase } from "../../../presentation/useCases/read/get_dependentes_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetDependentesUseCase
 */

export class GetDependentesUseCase extends BasePaginatedUseCase<Dependente> implements IGetDependentesUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) {
    super();
  }

  get dependentes(): Dependente[] {
    throw new Error("Method not implemented.");
  }

  async getDependentes(idFuncionario: number, page: number, rowsPerPage: number): Promise<void> {
    const response = await this.repository.getDependentes(idFuncionario, page, rowsPerPage);

    this._items = response.items;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
  }
}